// extracted by mini-css-extract-plugin
export var divider = "_t3-0";
export var systemMessage = "_t3-1";